<p-dialog
  [maximizable]="true"
  class="filters-modal add-cashout"
  header="Nuevo cashout"
  [modal]="true"
  [(visible)]="ctx.showNewTransaction"
  [style]="{ width: '1100px' }"
  *ngIf="ctx.showNewTransaction && ctx.currency == 'EUR'"
  (visibleChange)="ctx.closeAddModal()"
>
  <div class="new-transaction-form" *ngIf="ctx.newTransactionType !== 'csv'">
    <div class="form-heading">
      <div class="form-title">Ingresa los siguientes campos de tu cashout</div>
      <p-button
        *ngIf="ctx.canShowCsvUpload()"
        label="Subida en lotes (.CSV)"
        severity="secondary"
        [outlined]="true"
        (click)="ctx.showCsvUpload()"
      />
    </div>

    <div class="form-scroll-wrapper">
      <form class="form-container" [formGroup]="ctx.newTransactionForm">
        <div class="form-row">
          <div class="filter-column">
            <div class="form-item">
              <label for="status">ID de la transacción (Opcional)</label>
              <input
                type="number"
                placeholder="Ingresa el ID de la transacción"
                formControlName="transaction_id"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item" *ngIf="ctx.auth.hasRole(ctx.roles.Admin)">
              <label for="client_id">Cliente asignado</label>
              <p-dropdown
                placeholder="Elige un cliente"
                formControlName="client_id"
                [options]="ctx.userService.users"
                optionLabel="username"
                [filter]="true"
                filterBy="username"
                (onChange)="setDefaultBankByPriority()"
                appendTo="body"
              />
            </div>

            <div class="form-item">
              <label for="status">Tipo de transacción</label>
              <div class="account-type-picker">
                <div
                  *ngFor="let type of ctx.transactionTypes"
                  class="accu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.transaction_type.value ===
                    type.id
                  "
                  (click)="ctx.setTransactionType(type.id)"
                >
                  {{ type.id }}
                </div>
              </div>
            </div>
          </div>
          <div class="filter-column">
            <div class="form-item">
              <label for="status">Nombres</label>
              <input
                type="text"
                placeholder="Ingresa los nombres"
                formControlName="firstname"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item">
              <label for="status">Apellidos</label>
              <input
                type="text"
                placeholder="Ingresa los apellidos del recipiente"
                formControlName="lastname"
                pInputText
                class="id-input-filter"
              />
            </div>
          </div>
          <div class="filter-column">
            <div class="form-item">
              <label for="status">IBAN</label>
              <input
                type="tel"
                [placeholder]="'Ingresa el IBAN'"
                formControlName="account_number"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item">
              <label for="status">Monto</label>
              <input
                type="number"
                placeholder="Ingresa el monto del cashout"
                formControlName="amount"
                pInputText
                class="id-input-filter"
              />
            </div>
          </div>
        </div>

        <!-- Descripción y ClearJunction (mismo nivel del form) -->
        <div class="form-row form-row-extra" *ngIf="ctx.currency === 'EUR'">
          <div class="form-item form-item-description">
            <label for="eur_description">Descripción</label>
            <input
              id="eur_description"
              type="text"
              pInputText
              formControlName="description"
              placeholder="Ej. Payment to supplier, Birthday present"
              class="id-input-filter"
            />
          </div>
        </div>

        <!-- EUR SEPA: tipo de beneficiario + dirección (metadata para el job / proveedor) -->
        <div
          class="input-item clearjunction-payee-type"
          *ngIf="ctx.currency === 'EUR'"
        >
          <label for="clearjunction_payee_type">Tipo de beneficiario</label>
          <div class="account-type-picker">
            <div
              class="accu-type"
              [class.selected]="
                ctx.newTransactionForm.controls.clearjunction_payee_type
                  .value === 'individual'
              "
              (click)="setClearJunctionPayeeType('individual')"
            >
              Individual
            </div>
            <div
              class="accu-type"
              [class.selected]="
                ctx.newTransactionForm.controls.clearjunction_payee_type
                  .value === 'corporate'
              "
              (click)="setClearJunctionPayeeType('corporate')"
            >
              Corporativo
            </div>
          </div>
        </div>
        <div
          class="clearjunction-payee-form"
          *ngIf="ctx.currency === 'EUR'"
          formGroupName="clearjunction_payee"
        >
          <div class="form-title">
            Dirección del beneficiario (obligatoria para cashouts EUR)
          </div>

          <!-- Solo Dirección (común para Individual y Corporate) -->
          <div class="payee-address" formGroupName="address">
            <div class="form-row">
              <div class="form-item">
                <label for="add_cj_country">País</label>
                <p-dropdown
                  id="add_cj_country"
                  [formControl]="
                    $any(
                      ctx.newTransactionForm.get(
                        'clearjunction_payee.address.country'
                      )
                    )
                  "
                  [options]="ctx.countryOptions"
                  optionLabel="name"
                  optionValue="code"
                  placeholder="Elige el país"
                  [filter]="true"
                  filterBy="name,code"
                  [showClear]="true"
                  appendTo="body"
                />
              </div>
              <div class="form-item">
                <label for="add_cj_zip">Código postal</label>
                <input
                  id="add_cj_zip"
                  type="text"
                  inputmode="numeric"
                  maxlength="10"
                  pInputText
                  formControlName="zip"
                  placeholder="Ej. 28001 (5 dígitos - ClearJunction)"
                />
              </div>
              <div class="form-item">
                <label for="add_cj_city">Ciudad</label>
                <input
                  id="add_cj_city"
                  type="text"
                  pInputText
                  formControlName="city"
                  placeholder="Ej. Rome"
                />
              </div>
              <div class="form-item">
                <label for="add_cj_street">Calle</label>
                <input
                  id="add_cj_street"
                  type="text"
                  pInputText
                  formControlName="street"
                  placeholder="Ej. 12 Tourin"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="buttons-container">
      <p-button
        label="Cancelar"
        severity="danger"
        (click)="ctx.exitNewTransaction()"
      />
      <p-button
        label="Guardar cashout"
        [disabled]="ctx.newTransactionForm.invalid || ctx.addingTransaction"
        [loading]="ctx.addingTransaction"
        severity="secondary"
        (click)="saveTransaction()"
      />
    </div>
  </div>
  <div class="new-transaction-form" *ngIf="ctx.newTransactionType === 'csv'">
    <div class="form-heading">
      <div class="form-title">
        Selecciona el archivo .csv que contiene los cashouts a agregar
      </div>
      <a
        class="csv-template-link"
        [href]="'/csv/cashout/' + ctx.currency + '.csv'"
        [download]="ctx.currency + '.csv'"
      >
        Descargar plantilla CSV
      </a>
    </div>
    <div class="picker">
      <input
        id="cashout_csv_file_eur"
        class="csv-file-input"
        type="file"
        accept=".csv"
        (change)="ctx.onFileSelected($event)"
      />
      <label class="csv-upload-box" for="cashout_csv_file_eur">
        <span class="csv-upload-icon">
          <i class="pi pi-upload"></i>
        </span>
        <span class="csv-upload-copy">
          <span class="csv-upload-title">
            {{ ctx.selectedFile?.name || "Selecciona tu archivo CSV" }}
          </span>
          <span class="csv-upload-subtitle">
            {{
              ctx.selectedFile
                ? "Archivo listo para subir"
                : "Solo archivos .csv"
            }}
          </span>
        </span>
      </label>
      <div class="picker-actions">
        <p-button
          label="Volver al formulario"
          severity="secondary"
          [outlined]="true"
          (click)="ctx.showCashoutForm()"
        />
        <p-button
          label="Subir archivo"
          [disabled]="!ctx.selectedFile"
          [loading]="ctx.uploadingCSV"
          severity="secondary"
          (click)="ctx.uploadFile()"
        />
      </div>
    </div>
  </div>
</p-dialog>
